import { E_REQUEST_METHOD } from '../ServicesHelpers';
import { serviceCreator } from 'src/services/helpers/serviceCreator';
import { API_ENDPOINT, SSE_ENDPOINT, SYSTEM_REALM } from '../constants';
export var coreServices = {
    fetchMoConfig: function (realm) {
        return serviceCreator(E_REQUEST_METHOD.GET, API_ENDPOINT.CONFIGS.MO_CONFIG(realm), true, {
            enableDefaultEvents: true,
            noCache: true,
        });
    },
    fetchMoConfigSystem: function () {
        return serviceCreator(E_REQUEST_METHOD.GET, API_ENDPOINT.CONFIGS.MO_CONFIG(SYSTEM_REALM), true, {
            enableDefaultEvents: true,
        });
    },
    fetchI18NSystem: function (locale) {
        return serviceCreator(E_REQUEST_METHOD.GET, API_ENDPOINT.CONFIGS.I18N_MO_SYSTEM(locale), true, {
            enableDefaultEvents: true,
        });
    },
    fetchI18NRealm: function (realm, locale) {
        return serviceCreator(E_REQUEST_METHOD.GET, API_ENDPOINT.CONFIGS.I18N_MO_REALM(realm, locale), true, {
            enableDefaultEvents: false,
        });
    },
    fetchI18NKYC: function (realm, locale) {
        return serviceCreator(E_REQUEST_METHOD.GET, API_ENDPOINT.CONFIGS.I18N_KYC(realm), true, {
            enableDefaultEvents: true,
            headers: {
                'Accept-Language': locale,
            },
        });
    },
    fetchI18NDefaultLocale: function (locale) {
        return serviceCreator(E_REQUEST_METHOD.GET, API_ENDPOINT.CONFIGS.I18N_DEFAULT_LOCALE(locale), false, {
            params: { baseURL: '' },
            enableDefaultEvents: false,
        });
    },
    pingCases: function () {
        return serviceCreator(E_REQUEST_METHOD.GET, API_ENDPOINT.CASES.DEFAULT, false, {
            enableDefaultEvents: false,
        });
    },
    pingIAM: function () {
        return serviceCreator(E_REQUEST_METHOD.GET, API_ENDPOINT.IAM.DEFAULT, false, {
            enableDefaultEvents: false,
        });
    },
    pingConfigs: function () {
        return serviceCreator(E_REQUEST_METHOD.GET, API_ENDPOINT.CONFIGS.DEFAULT, false, {
            enableDefaultEvents: false,
        });
    },
    pingSearch: function () {
        return serviceCreator(E_REQUEST_METHOD.GET, API_ENDPOINT.SEARCH.DEFAULT, false, {
            enableDefaultEvents: false,
        });
    },
    pingKeycloak: function (realm) {
        return serviceCreator(E_REQUEST_METHOD.GET, API_ENDPOINT.KEYCLOAK.DEFAULT(realm), false, {
            enableDefaultEvents: false,
        });
    },
    pingSSE: function () {
        return serviceCreator(E_REQUEST_METHOD.GET, SSE_ENDPOINT.DEFAULT, false, {
            enableDefaultEvents: false,
        });
    },
};
